import React from 'react';
import SEOHead from './SEOHead';
import companyConfig from '../config/companyConfig';

function OurIndustry() {
  return (
    <>
      <SEOHead 
        title="Our Industry - Time2Find IT Solutions Across Sectors"
        description="Discover how Time2Find delivers tailored IT solutions across Healthcare, Finance, Retail, Manufacturing, Education, Energy, Travel, and Telecommunications sectors."
        keywords="industry solutions, healthcare IT, financial services technology, retail technology, manufacturing IT, education technology, energy solutions, telecom solutions"
        canonical="https://time2find.com/our-industry"
      />
      
      <div className="our-industry-page">
        {/* Hero Section */}
        <section className="industry-hero">
          <div className="industry-hero-overlay"></div>
          <div className="industry-hero-content">
            <h1 className="industry-hero-heading">
              <span className="highlight-blue">Industries</span> We Serve
            </h1>
          </div>
        </section>

        {/* Industries Section - From About Page */}
        <section className="industries-section">
          <div className="industries-container">
            <div className="industries-header">
              <h2 className="industries-title">{companyConfig.industries.title}</h2>
              <p className="industries-subtitle">{companyConfig.industries.subtitle}</p>
            </div>

            <div className="industries-sectors">
              {companyConfig.industries.sectors.map((sector) => (
                <div key={sector.id} className="sector-block">
                  <div className="sector-header" style={{ background: sector.gradient }}>
                    <i className={sector.id === 1 ? "fas fa-briefcase" : "fas fa-university"}></i>
                    <h3>{sector.name}</h3>
                  </div>
                  
                  <div className="sector-industries">
                    {sector.industries.map((industry, index) => (
                      <div key={index} className="industry-item">
                        <div className="industry-icon" style={{ color: sector.color }}>
                          <i className={`fas ${industry.icon}`}></i>
                        </div>
                        <span>{industry.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Cloud Solutions & Big Data Tools Section */}
        <section className="cloud-bigdata-section">
          <div className="cloud-bigdata-container">
            {/* Cloud Solutions - Grid Style */}
            <div className="tech-subsection cloud-style">
              <div className="tech-subsection-header">
                <div className="section-icon-badge cloud-badge">
                  <i className="fas fa-cloud"></i>
                </div>
                <h2 className="tech-subsection-title">Cloud Solutions</h2>
                <p className="tech-subsection-description">
                  Empowering your business with leading cloud platforms
                </p>
              </div>
              
              <div className="tech-logos-grid-cloud">
                {companyConfig.cloudBigDataCarousel.cloudSolutions.logos.map((logo, index) => (
                  <div key={index} className="tech-logo-box cloud-box">
                    <div className="logo-icon-wrapper">
                      <i className={logo.icon} style={{ color: logo.color }}></i>
                    </div>
                    <span>{logo.name}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Big Data Tools - Flowing Scroll Style */}
            <div className="tech-subsection bigdata-style">
              <div className="tech-subsection-header">
                <div className="section-icon-badge bigdata-badge">
                  <i className="fas fa-database"></i>
                </div>
                <h2 className="tech-subsection-title">Big Data & Analytics Tools</h2>
                <p className="tech-subsection-description">
                  Transform data into actionable intelligence with modern tools
                </p>
              </div>
              
              <div className="tech-logos-scroll-wrapper">
                <div className="tech-logos-scroll">
                  {companyConfig.cloudBigDataCarousel.bigDataTools.logos.map((logo, index) => (
                    <div key={index} className="tech-logo-box bigdata-box">
                      <div className="logo-icon-wrapper">
                        <i className={logo.icon} style={{ color: logo.color }}></i>
                      </div>
                      <span>{logo.name}</span>
                    </div>
                  ))}
                  {/* Duplicate for seamless loop */}
                  {companyConfig.cloudBigDataCarousel.bigDataTools.logos.map((logo, index) => (
                    <div key={`dup-${index}`} className="tech-logo-box bigdata-box">
                      <div className="logo-icon-wrapper">
                        <i className={logo.icon} style={{ color: logo.color }}></i>
                      </div>
                      <span>{logo.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default OurIndustry;
